import React, { useState } from "react";
import { addInternalNoteToFirestore } from "./internalNotesAction";
import { CREATE_INTERNAL_NOTE } from "./internalNotesConst";
import {
  Box,
  Textarea,
  Button,
  Stack,
  useToast,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";

export default function AddInternalNoteForm({ projectId, currentUser }) {
  const [noteText, setNoteText] = useState("");
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const dispatch = useDispatch()

  // 🔒 Admin-only guard
  if (!currentUser?.isAdmin) return null;

const handleSubmit = async () => {
  console.log("SUBMIT CLICKED");
  console.log("noteText:", noteText);
  console.log("projectId:", projectId);

  if (!noteText.trim() || !projectId) return;

  setLoading(true);

  try {
    const docRef = await addInternalNoteToFirestore({
      note: noteText,
      projectId,
      createdBy: currentUser.email,
    });

    console.log("DOC CREATED:", docRef.id);

    dispatch({
      type: CREATE_INTERNAL_NOTE,
      payload: {
        id: docRef.id,
        note: noteText,
        projectId,
        createdBy: currentUser.email,
        createdAt: new Date(),
      },
    });

    setNoteText("");

    toast({
      title: "Internal note added",
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  } catch (error) {
    console.error("Add internal note failed:", error);
  } finally {
    setLoading(false);
  }
};
  return (
    <Box p={4} bg="white" borderRadius="md" shadow="sm" borderWidth="1px">
      <Stack spacing={3}>

        <Textarea
          value={noteText}
          onChange={(e) => setNoteText(e.target.value)}
          placeholder="Write an internal note..."
          resize="vertical"
        />

        <Button
          colorScheme="purple"
          onClick={handleSubmit}
          isLoading={loading}
          alignSelf="flex-end"
        >
          Add Note
        </Button>

      </Stack>
    </Box>
  );
}